import { PLAYER_CONTENT_KIND } from '../constants';
import { playerLoadThunkAction } from './load';

export const playerLoadLinearChannelThunkAction = (id) => (dispatch) => {
  const payload = {
    kind: PLAYER_CONTENT_KIND.LINEAR_CHANNEL,
    id,
  };
  return dispatch(playerLoadThunkAction(payload));
};
